module.exports = __webpack_public_path__ + "img/person-photo-example2.67a327f8.jpg";